<template>
  <div class="statisticalRange">
    <!-- 导航栏 -->
    <nav-header head-title="修改上报统计范围"></nav-header>
    <div class="container">
      <!-- <div class="tips">
        在正式监测期内，针对上报标准科室关联的单元进行手卫生观察的督导人如下，可选择将哪些督导人的数据纳入上报，默认勾选“手卫生观察员”
      </div> -->
      <!-- 状态栏项 -->
      <div class="tips-item tips-item1">
        <div class="title df-between">
          <div class="left df-center">
            <div class="bar"></div>
            <div class="text">不允许再修改执行角色</div>
            <img
              src="../../assets/images/i-question.png"
              alt=""
              class="i-question"
              @click="rolePopShow =true"
            />
          </div>
          <van-switch
            v-model="allowEditChecked"
            size="25px"
            active-color="rgb(68,219,94)"
            @change="changeEditChecked"
            :disabled="reportStatus == 1"
          />
        </div>
        <div class="desc">
          如已经确定统计范围建议关闭修改权限，否则一旦修改又将影响统计范围
        </div>
      </div>
      <div class="tips-item tips-item2">
        <div class="title df-between">
          <div class="left df-center">
            <div class="bar"></div>
            <div class="text">修改纳入上报的范围</div>
          </div>
          <img
            src="../../assets/images/ic-edit.png"
            alt=""
            class="i-edit"
            v-if="deptTableList.length > 0 && reportStatus != 1 && !editStatus"
          />
          <div
            class="right edit-btn"
            v-if="deptTableList.length > 0 && reportStatus != 1 && !editStatus"
            @click="editReport"
          >
            修改
          </div>
        </div>
        <div class="desc">
          可按人指定哪些数据纳入上报时机数统计（默认“手卫生观察员”的时机数纳入上报）
        </div>
      </div>
      <van-tabs
        color="#1C91FF"
        title-inactive-color="#666666"
        title-active-color="#1C91FF" 
        v-model="tabIndex"
        @change="handTabChange"
      >
        <van-tab title="洗手/卫生手消毒"></van-tab>
        <van-tab title="外科手消毒"></van-tab>
      </van-tabs>
      <van-tabs
        background='#f2f2f2'
        swipe-threshold='4'
        line-height='0px'
        color="#1C91FF"
        title-inactive-color="#666666"
        title-active-color="#1C91FF"
        v-model="activeType"
        swipeable
        v-if="deptTableList && deptTableList.length > 0"
      >
        <van-tab
          title-class='two-level-tab'
          :title="item.deptName"
          v-for="(item, index) in deptTableList"
          :key="index"
        >
          <div class="statistical-list">
            <!-- 有数据 -->
            <template v-if="item.children.length > 0">
              <!-- 标题 -->
              <div class="statistical-title statistical-list-item">
                <div class="left t-left">督导人</div>
                <!-- <div class="center">已观察时机数</div> -->
                <div class="center t-center">{{tabIndex == 0 ? '观察医疗/护理时机数' : '观察医疗时机数'}}</div>
                <div class="rigth t-right">是否纳入上报</div>
              </div>
              <!-- 具体的条目 -->
              <div
                class="special-list"
                v-for="(item2, index2) in item.children"
                :key="index2"
              >
                <div class="statistical-list-item">
                  <div class="left">
                    <div class="name">{{ item2.userName }}</div>
                    <div class="tag df-center" v-if="item2.userPostName">
                      手卫生观察员
                    </div>
                  </div>
                  <div class="center">
                    {{ item2.docNum + (tabIndex == 0 ? "/" + item2.nurseNum : '') }}
                  </div>
                  <div
                    class="right"
                    @click="changeRadioCheck(item2)"
                    v-if="editStatus"
                  >
                    <van-radio
                      name="1"
                      :value="item2.isSelected"
                      checked-color="#1C91FF"
                    ></van-radio>
                  </div>
                  <div v-else class="right false-or-true">
                    <div class="right-true" v-if="item2.isSelected === '1'">
                      是
                    </div>
                    <div class="right-false" v-if="item2.isSelected === '0'">
                      否
                    </div>
                  </div>
                </div>
                <!-- <div class="statistical-list-item">
              <div class="left">
                <div class="name">李四</div>
                <div class="tag">手卫生观察员</div>
              </div>
              <div class="center">2</div>
              <div class="right">
                <van-radio
                  :name="true"
                  :value="testRadio"
                  @click="changeRadioCheck"
                  checked-color="#1C91FF"
                ></van-radio>
              </div>
            </div> -->
              </div>
              <div class="special-list">
                <div class="statistical-list-item">
                  <div class="left totatl-text">
                    <div class="name">合计</div>
                    <!-- <div class="tag df-center" v-if="item2.userPostName">
                      手卫生观察员
                    </div> -->
                  </div>
                  <div class="center total-text">
                    {{ tabIndex == 0 ? currentTotalCount : currentTotalCount.split('/')[0]}}
                  </div>
                  <div class="right">-</div>
                </div>
              </div>
              <!-- 合计 -->
              <!-- <div class="total-count statistical-list-item">
                合计纳入上报的时机数：{{ currentTotalCount }}
              </div> -->
            </template>
            <!-- 没有数据 -->
            <empty-component v-else />
            <!-- 刷新组件 -->
            <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell v-for="item in list" :key="item">
                <div class="statistical-item df-between">
                  <div class="name">
                    <span>张三</span>
                    <span>手卫生观察员</span>
                  </div>
                  <div class="count">25</div>
                  <input
                    type="checkbox"
                    id="cbox2"
                    value="second_checkbox"
                    checked="checked"
                    style="width: 20px; height: 20px; border: 1px solid #ccc"
                  />
                </div>
              </van-cell>
            </van-list>
          </van-pull-refresh> -->
          </div>
        </van-tab>
      </van-tabs>
      <!-- 外科手消毒没有选择科室时 -->
      <div class="not-dept-tips" v-if="tabIndex == 1 && hadLoad && (!deptTableList || deptTableList.length == 0)">
        上报科室中还未关联手术部（室），
        <span class="relevance-dept" @click="goRelevanceDept">立即去关联</span>
      </div>
      <!-- 没有数据 -->
      <empty-component
        v-if="tabIndex == 0 && hadLoad && (!deptTableList || deptTableList.length == 0)"
      />
      <div style="height: 70px"></div>
      <template v-if="deptTableList.length > 0 && reportStatus != 1">
        <!-- 修改按钮 -->
        <div class="submit-btn-group edit-btn-group" v-if="!editStatus">
          <div class="edit df-center" @click="editReport">
            <img src="../../assets/images/monitorRecord/i-edit.png" alt=""  />
            修改
          </div>
        </div>
        <!-- 取消确定按钮 -->
        <div class="submit-btn-group" v-else>
          <div class="cancel df-center" @click="cancelReport">取消</div>
          <div class="comfirm df-center" @click="comfirmReport">确定</div>
        </div>
      </template>
    </div>

    <!-- 弹框 -->
    <!-- 提示修改角色 -->
    <yd-popup
      v-model="rolePopShow"
      position="center"
      width="100%"
      :close-on-masker="false"
      class="ydPop"
    >
      <div class="yd-pop-inner">
        <img src="../../assets/images/i-report-pop.png" alt="" class="bg-role-pop">
        <div class="df-center know-btn" @click="closeRolePop">知道了</div>
      </div>
    </yd-popup>
    <!-- 提示弹框 -->
    <yd-popup
      v-model="ydPopShow"
      position="center"
      width="100%"
      :close-on-masker="false"
      class="ydPop"
    >
      <div class="yd-pop-inner">
        <img
          src="../../assets/images/monitorRecord/bg-gesture.png"
          alt=""
          class="bg-gesture"
        />
        <div class="m-dialog">左右滑动可选择督导的 标准科室</div>
        <div class="df-center know-btn" @click="closePoP">知道了</div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import navHeader from "../../components/header/header.vue";
import Vue from "vue";
import { mapState } from "vuex";
import { Popup } from "vue-ydui/dist/lib.rem/popup";
import emptyComponent from "../../components/empty-component/empty-component.vue";
Vue.component(Popup.name, Popup);
import { Toast, Loading, Confirm } from "vue-ydui/dist/lib.rem/dialog";
export default {
  components: {
    navHeader,
    emptyComponent,
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
    currentTotalCount() {
      let totalCount = 0;
      let totalDocCount = 0
      let totalNurseCount = 0
      let currentArr = this.deptTableList[this.activeType].children;
      if (currentArr.length > 0) {
        console.log(currentArr, "7777");
        totalCount = currentArr.reduce((sum, num) => {
          // let currentNum = num.isSelected === "1" ? num.handTimeNum : 0;
          let currentNum =
            num.isSelected === "1" ? num.docNum + num.nurseNum : 0;
          return sum + currentNum;
        }, 0);
        totalDocCount = currentArr.reduce((sum, num) => {
          // let currentNum = num.isSelected === "1" ? num.handTimeNum : 0;
          let currentNum =
            num.isSelected === "1" ? num.docNum  : 0;
          return sum + currentNum;
        }, 0);
        totalNurseCount = currentArr.reduce((sum, num) => {
          // let currentNum = num.isSelected === "1" ? num.handTimeNum : 0;
          let currentNum =
            num.isSelected === "1" ?  num.nurseNum : 0;
          return sum + currentNum;
        }, 0);
      }
      return `${totalDocCount}/${totalNurseCount}`;
    },
  },
  data() {
    return {
      // 是否允许修改统计范围
      allowEditChecked: false,
      rolePopShow: false,
      hadLoad: false,
      reportStatus: 0,
      ydPopShow: false,
      editStatus: false,
      testRadio: true,
      tabIndex: 0,
      activeType: 0,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      deptTableList: [],
      tableList: [
        {
          deptName: "骨科",
          list: [
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 1, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 1, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 1, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 0, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 0, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 0, // 观察员
            },
            {
              name: "张三",
              count: 2,
              checked: false,
              status: 0, // 观察员
            },
          ],
        },
        {
          deptName: "综合ICU",
          list: [],
        },
        {
          deptName: "呼吸科(组)",
          list: [],
        },
        {
          deptName: "感染病(组)",
          list: [],
        },
        {
          deptName: "感染病(组)",
          list: [],
        },
        {
          deptName: "感染病(组)",
          list: [],
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.ydPopShow = from.path === "/" || from.path === "/monitorRptIndex";
    });
  },
  created() {
    this.reportStatus = this.$route.query.reportStatus;
    this.initUserHandActivityInfo();
    this.searchStandardDeptHandDatas();
  },
  methods: {
    goRelevanceDept(){
      this.$router.push({
        path: '/conFirmReportDept',
        query:{
        }
      })
    },
    handTabChange(){
      this.activeType = 0
      this.searchStandardDeptHandDatas();
    },
    closeRolePop() {
      this.rolePopShow = false;
    },
    // 获取用户手卫生活动的用户信息
    initUserHandActivityInfo() {
      let params = {
        userId: this._userInfo.data.userId,
        sub_id: "",
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          handTaskId: this.$route.query.taskId,
        },
        malVersion: "A0",
      };
      this.$http.getUserHandActivityInfo(params).then((res) => {
        console.log(res, "用户信息...");
        if (res.code === 0) {
          this.allowEditChecked = res.data.swiftRoleAbility == "0";
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 改变选中状态
    changeEditChecked(val) {
      this.editHandRoleSwiftAbility();
    },
    // 修改统计范围
    changeReportingScope() {
      console.log(this.deptTableList);
      let newStandardDeptList = this.generatorEditRangeParams(
        this.deptTableList
      );
      console.log(newStandardDeptList, "构建后的参数..");
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          standardDeptList: newStandardDeptList,
          userId: this._userInfo.data.userId,
          comId: this._userInfo.data.comId,
          taskId: this.$route.query.taskId,
          indexCode: this.tabIndex == 0 ? 1 : 2 // 区分是修改手卫生依从性统计范围还是外科手消毒：1表示手卫生,2表示外科手消毒
        },
      };
      console.log(params, "请求参数");
      this.$http.changeReportingScope(params).then((res) => {
        if (res.code == 0) {
          this.$toast(res.msg);
          this.editStatus = false;
          setTimeout(() => {
            this.searchStandardDeptHandDatas();
          }, 600);
        } else {
          this.$toast(res.msg);
        }
        console.log(res, "改变改变...");
      });
    },
    // 设置允许修改手卫生执行角色
    async editHandRoleSwiftAbility() {
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          taskId: this.$route.query.taskId,
          userId: this._userInfo.data.userId,
          comId: this._userInfo.data.comId,
          operation: this.allowEditChecked ? "0" : "1",
        },
      };
      let res = await this.$http.editHandRoleSwiftAbility(params);
      console.log(res, "結果。。。");
      if (res.code == 0) {
        this.$toast(res.msg);
      } else {
        this.$toast(res.msg);
      }
    },
    // 构建修改统计范围的参数
    generatorEditRangeParams(arr = []) {
      let newArr = arr.map((v1, i1) => {
        let isSelectedArr = v1.children.filter((v3) => true);
        let userArr = isSelectedArr.map((v2, i2) => {
          return {
            userId: v2.userId ? v2.userId : "",
            userName: v2.userName,
            userPost: v2.userPost ? v2.userPost : "",
            isSelected: v2.isSelected,
          };
        });

        return {
          deptId: v1.deptId,
          deptName: v1.deptName ? v1.deptName : "",
          userList: userArr,
        };
      });
      return newArr;
    },
    // 获取上报统计范围
    searchStandardDeptHandDatas() {
      console.log(this._userInfo, "777");
      // return
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          taskId: this.$route.query.taskId,
          taskLinkId: this.$route.query.taskLinkId,
          indexCode: this.tabIndex == 0 ? 1 : 2 // 区分是修改手卫生依从性统计范围还是外科手消毒：1表示手卫生,2表示外科手消毒
        },
      };

      this.$http.searchStandardDeptHandDatas(params).then((res) => {
        this.hadLoad = true;
        if (res.code == 0) {
          let arr = res.data ? res.data : [];
          arr.forEach((v) => {
            v.children = v.children ? v.children : [];
          });
          this.deptTableList = arr;
          // this.deptTableList = [];
        } else {
          this.$toast(res.msg);
        }
        console.log(res);
      });
    },
    closePoP() {
      this.ydPopShow = false;
    },
    cancelReport() {
      this.editStatus = false;
    },
    comfirmReport() {
      this.changeReportingScope();
      return;
      this.editStatus = false;
    },
    editReport() {
      this.editStatus = true;
    },
    changeRadioCheck(item) {
      item.isSelected = item.isSelected === "0" ? "1" : "0";
    },
    onLoad() {
      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.list = [];
      //     this.refreshing = false;
      //   }
      //   for (let i = 0; i < 10; i++) {
      //     this.list.push(this.list.length + 1);
      //   }
      //   this.loading = false;
      //   if (this.list.length >= 40) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
<style lang='scss'>
  .two-level-tab.van-tab--active{
    .van-tab__text{
      background-color: #1C91FF;
      color: #fff;
      border-radius: 50px;
      padding: 3px 10px;
    }
  }
  .two-level-tab{
    .van-tab__text{
      background-color: #fff;
      color: #333;
      border-radius: 50px;
      padding: 3px 10px;
    }
  }
</style>
<style lang='scss' scoped>
.statisticalRange {
  background-color: #f2f2f2;
  height: 100vh;
  font-size: 12px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  .not-dept-tips{
    height: 80px;
    line-height: 80px;
    text-align: center;
    background-color: #fff;
    .relevance-dept{
      color: #1c91ff;
      text-decoration: underline;
    }
  }
  .yd-popup-center.yd-popup-show {
    transform: translate(-50%, -70%) !important;
  }
  .container {
    flex: 1;
    overflow: scroll;
  }
  .tips {
    text-align: left;
    box-sizing: border-box;
    padding: 14px 12px 10px;
    color: rgb(255, 102, 0);
    background: #f7f8fa;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  .tips-item {
    background-color: #fff;
    padding: 10px 12px 15px;
    // margin-bottom: 5px;
    .title {
      align-items: center;
      .bar {
        margin-right: 10px;
        width: 4px;
        height: 18px;
        opacity: 1;
        background: #1c91ff;
        border-radius: 2px;
      }
      .text {
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 25px;
      }
      .i-question {
        width: 18px;
        height: 18px;
        margin-left: 8px;
      }
      .i-edit {
        width: 16px;
        height: 16px;
        margin-left: auto;
        margin-right: 8px;
      }
      .edit-btn {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #1c91ff;
        line-height: 20px;
      }
    }
    .desc {
      margin-top: 5px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
      line-height: 20px;
    }
  }
  .bg-role-pop {
    margin: 0 auto;
    width: 291px;
    height: 323px;
  }
  .tips-item1 {
    border-top: 1px solid #eeeeee;
    margin-bottom: 10px;
  }
  .tips-item2 {
    border-bottom: 1px solid #eeeeee;
  }

  .statistical-list {
    // margin-top: 10px;
    background-color: #fff;
    .statistical-list-item {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 12px;
      height: 44px;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      color: #333333;
    }
    .total-count {
    }
    .statistical-title {
      color: #666;
    }
    .left {
      width: 151px;
    }
    .center {
      width: 84px;
      margin: 0 22px 0 10px;
    }
    .right {
      width: 84px;
      margin-left: auto;
      text-align: center;
    }
    .totatl-text {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      color: #333333;
    }
    .t-left {
      width: 100px;
    }
    .t-center {
      width: 135px;
      margin-right: 10px;
    }
    .t-right {
    }
    .special-list {
      box-sizing: border-box;
      padding-left: 12px;
      .statistical-list-item {
        padding-left: 0;
      }
      .left {
        display: flex;
        align-items: center;
        .name {
          margin-right: 5px;
        }
        .tag {
          flex-shrink: 0;
          width: 90px;
          height: 21px;
          // padding: 2px 9px;
          border: 1px solid #40d090;
          border-radius: 101px;
          font-size: 12px;
          color: #40d090;
          // line-height: 17px;
        }
      }
      .center {
        text-align: center;
      }
      .right {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .false-or-true {
        font-size: 16px;
        .right-true {
          color: #1c91ff;
        }
        .right-false {
          color: #999999;
        }
      }
    }
  }

  .ydPop {
    box-sizing: border-box;
    .yd-pop-inner {
      padding-top: 120px;
      // background-color: pink;
      .bg-gesture {
        // margin-top: 50px;
        margin: 0 auto;
        width: 236px;
        height: 138px;
        font-weight: 400;
      }
      .m-dialog {
        width: 206px;
        height: 83px;
        margin: 35px auto 0;
        box-sizing: border-box;
        background: url("../../assets/images/monitorRecord/bg-dialog.png");
        background-size: 100% 100%;
        padding: 22px 18px 0;
        font-size: 17px;
        color: #ffffff;
        line-height: 24px;
      }
      .know-btn {
        margin: 44px auto 0;
        width: 108px;
        height: 40px;
        opacity: 1;
        border: 1px solid #26b4ff;
        border-radius: 101px;
        font-size: 16px;
        color: #26b4ff;
      }
    }
  }

  .submit-btn-group {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 99;
    display: flex;
    height: 59px;
    div {
      flex: 1;
      height: 100%;
    }
    .cancel {
      background: #ffffff;
      font-size: 18px;
      color: #1c91ff;
    }
    .comfirm {
      background: #1c91ff;
      font-size: 18px;
      color: #ffffff;
    }
    .edit {
      background: #ffffff;
      font-size: 18px;
      color: #1c91ff;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .edit-btn-group {
    left: -999px;
  }
}
</style>